/**
 * Browser storage left behind by features the app no longer has, dropped when the app starts. The guided tour
 * (removed 2026-10-30) marked each page's tour as seen with `kirigami.tour.<id>.completed`. Once no browser is likely
 * to hold these keys any more, this file can go.
 */
const RETIRED_PREFIXES = ['kirigami.tour.'];

export function dropRetiredStorage(storage: Storage | null = localStorageOrNull()): void {
  if (!storage) return;
  try {
    const retired: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key && RETIRED_PREFIXES.some((prefix) => key.startsWith(prefix))) retired.push(key);
    }
    for (const key of retired) storage.removeItem(key);
  } catch {
    // Storage the browser will not let us touch: nothing to clean.
  }
}

function localStorageOrNull(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}
